import { getRecipientNameCHIRP } from 'documents-ui/utils/getRecipientName';
import * as links from 'documents-lib/js/lib/links';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Header } from 'foundations-components/transitional/components/Header';
import { Link } from 'foundations-components/transitional/components/Link';
import { ContactAvatarCHIRP } from '../../ContactAvatarCHIRP';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DetailContactCardCHIRP = ({
  contact
}) => {
  const renderName = () => {
    const nameNode = contact ? getRecipientNameCHIRP(contact) : null;
    if (contact && contact.contactId && nameNode) {
      return /*#__PURE__*/_jsx(H3, {
        wordBreak: "break-all",
        children: /*#__PURE__*/_jsx(Link, {
          target: "_blank",
          external: true,
          href: links.getContactProfileURL(contact.contactId),
          children: nameNode
        })
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.recipientsTable.row.someone"
    });
  };
  return /*#__PURE__*/_jsx(Header, {
    title: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "500",
      children: [/*#__PURE__*/_jsx(ContactAvatarCHIRP, {
        contact: contact,
        size: "md"
      }), renderName()]
    }),
    paddingInlineStart: "400",
    paddingBlockStart: "0"
  });
};